import { Button, Col, Form, Input, Layout, Row } from "antd";
import { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import signinLogo from "../../assets/images/logo-for-logins.png";
import apiPath from "../../constants/apiPath";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import { AuthContext } from "../../context/AuthContext";
import _ from "lodash";

const { Content } = Layout;

const OtpIndex = () => {
  const navigate = useNavigate();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const location = useLocation();
  const { email } = location.state;
  const { setIsLoggedIn, setUserProfile } = useContext(AuthContext);

  const onSubmit = () => {
    if (!otp?.join) return ShowToast("Please enter OTP!", Severty.ERROR);
    if (!email) return ShowToast("Please enter email!", Severty.ERROR);

    const payload = {
      email,
      otp: otp?.join(""),
    };

    setLoading(true);
    request({
  url: apiPath.verifyOTP,
  method: "POST",
  data: { ...payload },
  onSuccess: (data) => {
    setIsLoggedIn(true);
    localStorage.setItem("token", data?.access_token);
    localStorage.setItem("userProfile", JSON.stringify(data?.user));
    setUserProfile(data?.user);

    ShowToast(data.message || "OTP verified successfully!", Severty.SUCCESS);
    setTimeout(() => navigate("/vendors"), 200);
  },
}).finally(() => {
  setLoading(false); // ✅ hamesha chalega (success + error dono case me)
});

  };

  const handleChange = (value, index) => {
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        document.getElementById(`otp-input-${index - 1}`).focus();
        const newOtp = [...otp];
        newOtp[index - 1] = "";
        setOtp(newOtp);
      }
    }
  };

  return (
    <div className="main-new-login-page-designe-divv">
      <Layout className="layout-default layout-signin">
        
        <Content className="signin">
          <Row>
            <Col span={24} lg={24} className="contant-bg-sign">
              <div className="signin-box">
                <div className="signup-logo">
                  <img src={signinLogo} alt="Logo" />
                  <h4>Enter OTP</h4>
                  <p>We’ve sent an OTP to your registered email</p>
                </div>

                <div className="otp-inputs">
                  {otp.map((digit, index) => (
                    <Input
                      key={index}
                      id={`otp-input-${index}`}
                      maxLength={1}
                      value={digit}
                      onChange={(e) => handleChange(e.target.value, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      style={{
                        width: 45,
                        height: 45,
                        margin: "0 5px",
                        textAlign: "center",
                        fontSize: "18px",
                      }}
                    />
                  ))}
                </div>

                <Button
                  type="primary"
                  block
                  loading={loading}
                  style={{ marginTop: 20, height: 45, fontSize: 16 }}
                  onClick={onSubmit}
                >
                  Verify OTP
                </Button>
                <span className="new-back_spann" onClick={() => navigate(-1)}>Back</span>
              </div>
            </Col>
          </Row>
        </Content>
      </Layout>
    </div>
  );
};

export default OtpIndex;
